/* beadboo — Size guide (snippets/beadboo-size-guide.liquid), 2026-09-07.
   Общий для PDP и standalone-конструктора. Открывает диалог ХОЗЯИН
   (beadboo-size в beadboo-customizer.js / bb-builder.js) — здесь только то,
   что внутри: закрытие, строки-кнопки и подбор по цифре.

   Выбор размера отдаём наружу событием `bb:size-pick` (bubbles, detail.size = 'XXS'|'XS'|'S'|'M'|'L'):
   PDP ставит его в селект, конструктор — в карточку. Диалог после этого закрывается. */
(function () {
  'use strict';
  var RANGES = [['XXS', 6, 9], ['XS', 8, 12], ['S', 11, 15], ['M', 14, 19], ['L', 18, 24]];

  function sizeFor(inches) {
    // перекрытия тиров: берём больший из подходящих — правило «between sizes → larger»
    var hit = null;
    for (var i = 0; i < RANGES.length; i++) {
      if (inches >= RANGES[i][1] && inches <= RANGES[i][2]) hit = RANGES[i][0];
    }
    if (hit) return hit;
    if (inches > 0 && inches < RANGES[0][1]) return RANGES[0][0];   // меньше самого маленького тира
    return null;
  }

  function init(dlg) {
    if (dlg.dataset.bbgReady) return;
    dlg.dataset.bbgReady = '1';

    var rows = Array.prototype.slice.call(dlg.querySelectorAll('[data-bbg-size]'));
    var num = dlg.querySelector('[data-bbg-num]');
    var out = dlg.querySelector('[data-bbg-out]');
    var units = Array.prototype.slice.call(dlg.querySelectorAll('[data-bbg-unit]'));
    var unit = 'in';

    function close() {
      if (typeof dlg.close === 'function' && dlg.open) dlg.close();
      else dlg.removeAttribute('open');
    }

    var closeBtn = dlg.querySelector('[data-bbg-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) close(); // тап по подложке
    });

    rows.forEach(function (r) {
      r.addEventListener('click', function () {
        dlg.dispatchEvent(new CustomEvent('bb:size-pick', { bubbles: true, detail: { size: r.dataset.bbgSize } }));
        close();
      });
    });

    function find() {
      rows.forEach(function (r) { r.classList.remove('is-hit'); });
      if (!num || !out) return;
      var raw = parseFloat(num.value);
      if (!raw || raw <= 0) { out.textContent = ''; return; }
      var inches = unit === 'cm' ? raw / 2.54 : raw;
      var s = sizeFor(inches);
      if (!s) {
        out.textContent = inches > 24 ? 'Over 24″ — write to us and we’ll make it longer.' : '';
        return;
      }
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].dataset.bbgSize === s) rows[i].classList.add('is-hit');
      }
      out.textContent = 'That’s size ' + s + ' — tap the row to pick it.';
    }
    if (num) num.addEventListener('input', find);
    units.forEach(function (b) {
      b.addEventListener('click', function () {
        unit = b.dataset.bbgUnit;
        units.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        find();
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bbg]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // секция могла перерисоваться в редакторе темы
  document.addEventListener('shopify:section:load', boot);
})();
